var _circle, _path, _circle2, _path2, _path3, _path4, _path5, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrativeIconDebt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.5898,
    r: 32,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.83 50.7426C11.5424 50.7426 20.5721 33.2174 27.4324 24.9297H36.9896C43.8499 33.2174 52.1176 50.7426 31.83 50.7426Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.1636,
    cy: 38.5083,
    r: 7.34523,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M32.2129 33.6866C28.4674 33.6866 25.4074 36.4054 25.1292 39.8612C25.1193 39.6579 25.1094 39.4631 25.1094 39.2513C25.1094 34.9317 28.2886 31.4336 32.2129 31.4336C36.1372 31.4336 39.3164 34.9401 39.3164 39.2513C39.3164 39.4546 39.3164 39.6579 39.2965 39.8612C39.0184 36.4054 35.9484 33.6866 32.2129 33.6866V33.6866Z",
    fill: "#1A1E23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1548 36.3216C34.0504 35.4069 33.0549 35.2016 32.1825 35.1983C31.0417 35.1933 29.9027 36.173 30.3053 37.2145C30.7005 38.2377 32.0502 38.4397 33.0307 38.8035C33.4557 38.9604 33.9516 39.1741 34.1883 39.5463C34.481 40.0086 34.4046 40.5644 34.0821 40.9967C33.7596 41.429 33.2432 41.686 32.6597 41.7762C31.7128 41.9231 30.3557 41.7178 30.0257 40.7714C29.9698 40.6111 29.9511 40.4426 29.9586 40.2757",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1641 34.3154V42.7018",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8322 14.9308C34.2752 15.2467 34.524 15.6751 34.524 16.1218C34.8372 15.7349 35.3532 15.4527 35.9583 15.3371C36.5634 15.2215 37.2081 15.282 37.7506 15.5054C38.2931 15.7287 38.689 16.0966 38.8512 16.5281C39.0133 16.9595 38.9284 17.4193 38.6152 17.8061L35.9583 22.6021H28.366L25.709 17.8061C25.3958 17.4193 25.3109 16.9595 25.4731 16.5281C25.6352 16.0966 26.0311 15.7287 26.5736 15.5054C27.1161 15.282 27.7609 15.2215 28.366 15.3371C28.9711 15.4527 29.4867 15.7349 29.7999 16.1218C29.7999 15.6751 30.0488 15.2467 30.4918 14.9308C30.9347 14.6149 31.5355 14.4375 32.162 14.4375C32.7884 14.4375 33.3892 14.6149 33.8322 14.9308Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.1465,
    y: 22.5928,
    width: 12.1254,
    height: 3.88672,
    rx: 1,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_5138_49007",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2715 22.5928H26.1465V24.542H38.2715V22.5928Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.2715 22.5928H26.1465V24.542H38.2715V22.5928Z",
    fill: "#1A1E23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1465 22.5928V20.5928H24.1465V22.5928H26.1465ZM38.2715 22.5928H40.2715V20.5928H38.2715V22.5928ZM38.2715 24.542V26.542H40.2715V24.542H38.2715ZM26.1465 24.542H24.1465V26.542H26.1465V24.542ZM26.1465 24.5928H38.2715V20.5928H26.1465V24.5928ZM36.2715 22.5928V24.542H40.2715V22.5928H36.2715ZM38.2715 22.542H26.1465V26.542H38.2715V22.542ZM28.1465 24.542V22.5928H24.1465V24.542H28.1465Z",
    fill: "#1A1E23",
    mask: "url(#path-9-inside-1_5138_49007)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrativeIconDebt);
export default __webpack_public_path__ + "static/media/illustrative-icon-debt.ab902bfaeec5abd1dbd249070f39651b.svg";
export { ForwardRef as ReactComponent };